/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
//@ts-ignore
import Slider from "react-slick";

import { IObrienMainFaderViewProps } from './obrien-main-fader';

export default (props: IObrienMainFaderViewProps) => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        fade: true,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: false,
        cssEase: 'linear'
    };

    const { slide1Image, slide2Image, slide3Image, slide4Image, slide5Image, obHeroImageOverlay, obHeroContent, obHeroButtonLink, obHeroButtonText } = props;

    return (
        <section className="SliderBanners main-fader">
            <div className="ob-hero">
                <div className="text-container">
                    <div>
                        {obHeroContent && obHeroContent.length > 0 ? (
                            <>
                            <div className="inside-lg" dangerouslySetInnerHTML={{ __html: obHeroContent }}></div>
                            <div className="around-button"><span className="myButton"><a className="button" href={obHeroButtonLink}>{obHeroButtonText}</a></span></div>
                            </>
                        ) : 
                            <>
                            <div className="inside-lg"><a href={obHeroButtonLink}><div className="heroImgOverlay">{obHeroImageOverlay}</div></a></div>
                            <div className="around-button"><span className="myButton"><a className="button blackFriday" href={obHeroButtonLink}>{obHeroButtonText}</a></span></div>
                            </>
                        }
                        
                    </div>
                </div>

                <Slider {...settings}>

                    {slide1Image ? (
                    <div className="sliiick hero-img-fix">
                        {slide1Image}
                    </div>
                    ) : null}
                    {slide2Image ? (
                    <div className="sliiick hero-img-fix">
                        {slide2Image}
                    </div>
                    ) : null}        
                    {slide3Image ? (
                    <div className="sliiick hero-img-fix">
                        {slide3Image}
                    </div>
                    ) : null} 
                    {slide4Image ? (
                    <div className="sliiick hero-img-fix">
                        {slide4Image}
                    </div>
                    ) : null}     
                    {slide5Image ? (
                    <div className="sliiick hero-img-fix">
                        {slide5Image}
                    </div>
                    ) : null}      

                </Slider>
            </div>
        </section>
    );
};
